import { Component, OnInit, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { User } from 'src/app/front-user/shared/models/user.model';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { Languages, FormMode, ServiceStatus, SUMeasurementDecision } from 'src/app/shared/models/enums.model';
import { TranslateService } from '@ngx-translate/core';
import { SmallUnitadminDTO } from '../shared/models/small-units-admin.model';
import { SmallUnitsAdminService } from '../shared/services/small-units.service.admin';
import { SmallUnitRequest } from 'src/app/front-user/services/small-units/shared/models/Small-Unit-Request.model';
import { EntranceRequestComponent } from 'src/app/front-user/services/small-units/entrance-request/entrance-request.component';
import { SmallUnitsServiceFE } from 'src/app/front-user/services/small-units/shared/services/small-units.service';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-estimate-fees',
  templateUrl: './measurement-Estimate-fees-component.html'
})

export class MeasurementEstimateFeesComponent implements OnInit {
  submitted = false;
  loading = false;
  baseRequestId: string = '';
  requestStatus: number;
  baseRequestDTO: BaseRequest //= new BaseRequest();
  decision = SUMeasurementDecision;
  decisionKeys = Object.keys(this.decision).filter(key => isNaN(Number(key)));
  decisionValue: number;
  displayedLang: string;
  public estimateFeesForm: FormGroup;
  user: User = new User();
  showRequest = false;
  MeasurmentEstimateFeesObject: SmallUnitadminDTO = new SmallUnitadminDTO();
  feesEstimationObj: SmallUnitRequest = new SmallUnitRequest();
  agentId: string;
  responseObj: ResponseObject = new ResponseObject();
  public FormMode: any = FormMode;
  public formMode: any = FormMode.Add;
  numberRegex: string = '^[0-9]+(\\.?[0-9]+)?$';
  maxNetTonnage: number = 299.999;
  @Input() public isShow: boolean = true;
  @ViewChild('EntranceRequest',{static: false}) EntranceRequest: EntranceRequestComponent;
  public disableForm: boolean = false;
  isErrorMessage: boolean = false;
  lockTaskErrorMessage: boolean = false;
  constructor(private formBuilder: FormBuilder,
    private globalSrv: GlobalServices,
    private route: ActivatedRoute, private router: Router,
    private authenticationService: AuthenticationService, private alertService: AlertService,
    private translate: TranslateService,
    private suServ: SmallUnitsServiceFE, private suAdminServ: SmallUnitsAdminService) {
    this.isShow = true;
    if (history.state.data && history.state.data.requestId) {
      this.baseRequestId = history.state.data.requestId;
      this.getBaseRequest();
    } else {
      window.history.back();
    }
    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
    this.user = this.globalSrv.user;

  }

  ngOnInit(): void {
    this.buildForm(null);
  }
  buildForm(decision) {
    this.estimateFeesForm = this.formBuilder.group({
      Decision: ['', [Validators.required]],
    });
    if (decision == SUMeasurementDecision.Approve) {
      this.estimateFeesForm = this.formBuilder.group({
        Decision: ['', [Validators.required]],
        EstimatedNetTonnage: ['', [Validators.required, Validators.pattern(this.numberRegex), Validators.max(this.maxNetTonnage)]],
        EstimatedSDR: ['', [Validators.required, Validators.pattern(this.numberRegex)]],
        EstimatedFeesValue: ['0', [Validators.required, Validators.pattern(this.numberRegex)]],
      });
    }
    if (decision == SUMeasurementDecision.MoreInformation) {
      this.estimateFeesForm = this.formBuilder.group({
        Decision: ['', [Validators.required]],
        MeasEstimationMoreInformation: ['', [Validators.required]],
      });
    }
    if (decision == SUMeasurementDecision.Reject) {
      this.estimateFeesForm = this.formBuilder.group({
        Decision: ['', [Validators.required]],
        MeasEstimationRejectReason: ['', [Validators.required]],
      });
    }
  }
  get f() {
    return this.estimateFeesForm.controls;
  }
  changeDecision(value) {
    this.buildForm(value);
    this.estimateFeesForm.patchValue({
      Decision: value
    });
    this.decisionValue = value;
  }
  getBaseRequest() {
    this.suServ.get(this.baseRequestId).pipe(first()).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        if (this.responseObj.Success) {

          this.feesEstimationObj = this.responseObj.Data;
          this.requestStatus = this.feesEstimationObj.StatusId;
          this.agentId = this.feesEstimationObj.RequestorId;
          // check if component open fron request history
          if (history.state.data && history.state.data.isCompleted) {

            this.formMode = FormMode.Readonly;
            //to view "more information" data in case Measurement officer require it from agent and penending agent update
            //or after agent update request and pending Measurement officer approval
            if (this.feesEstimationObj.MeasEstimationActionId == SUMeasurementDecision.MoreInformation) {
              this.decisionValue = this.feesEstimationObj.MeasEstimationActionId;
              this.buildForm(this.decisionValue);
              this.estimateFeesForm.patchValue({
                Decision: this.decisionValue,
                MeasEstimationMoreInformation: this.feesEstimationObj.MeasEstimationMoreInformation,
              });
            } else if (this.feesEstimationObj.MeasEstimationActionId == SUMeasurementDecision.Reject) {
              this.decisionValue = this.feesEstimationObj.MeasEstimationActionId;
              this.buildForm(this.decisionValue);
              this.estimateFeesForm.patchValue({
                Decision: this.decisionValue,
                MeasEstimationRejectReason: this.feesEstimationObj.MeasEstimationRejectReason,
              });
            } else {
              this.decisionValue = this.feesEstimationObj.MeasEstimationActionId;
              this.buildForm(this.decisionValue);
              this.estimateFeesForm.patchValue({
                Decision: this.decisionValue,
                EstimatedFeesValue: this.feesEstimationObj.EstimatedFeesValue,
                EstimatedSDR: this.feesEstimationObj.EstimatedSDR,
                EstimatedNetTonnage: this.feesEstimationObj.EstimatedNetTonnage,
              });
            }
            this.estimateFeesForm.disable();
            // this.disableForm=true;
            this.estimateFeesForm.controls.Decision.disable();
          } else if (this.requestStatus == ServiceStatus.SmallUnit_PendingEstimateFees) {
            this.formMode = FormMode.Add;
            this.estimateFeesForm.enable();
          } else {
            // to hide submit button
            this.formMode = FormMode.Readonly;
            this.estimateFeesForm.disable();
            this.decisionValue = SUMeasurementDecision.Approve;
            //this.buildForm(this.decisionValue);
            this.changeDecision(this.decisionValue);
            this.estimateFeesForm.patchValue({
              Decision: SUMeasurementDecision.Approve,
              EstimatedFeesValue: this.feesEstimationObj.EstimatedFeesValue,
              EstimatedSDR: this.feesEstimationObj.EstimatedSDR,
              EstimatedNetTonnage: this.feesEstimationObj.EstimatedNetTonnage
            });
          }

        }
      }

    )
  }
  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.estimateFeesForm.invalid) {
      return;
    }
    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    this.loading = true;
    this.MeasurmentEstimateFeesObject = this.estimateFeesForm.value;
    this.MeasurmentEstimateFeesObject.AdminEmail = this.user.UserName;
    this.MeasurmentEstimateFeesObject.Id = this.baseRequestId;
    this.MeasurmentEstimateFeesObject.MeasEstimationActionId = this.decisionValue;
    this.suAdminServ.AddMeasurementFeesDecision(this.MeasurmentEstimateFeesObject)
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            this.globalSrv.isLoaderEnabled = false;
            this.estimateFeesForm.reset();
            this.loading = false;
            this.showRequest = true;
            this.isErrorMessage = false;
          }
          else if (data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
            this.lockTaskErrorMessage = true;
            this.showRequest = true;
            this.globalSrv.isLoaderEnabled = false;
          }
          else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage = true;
            this.loading = false;
          }

        });
  }
  NetTonnageChanged(event) {
    if (this.estimateFeesForm.controls.EstimatedNetTonnage.valid && this.estimateFeesForm.controls.EstimatedSDR.valid) {
      let netTonnage = event.target.value;
      let SDRRate = this.estimateFeesForm.controls.EstimatedSDR.value;
      if (SDRRate != "") {
        this.estimateFeesForm.patchValue({
          EstimatedFeesValue: this.calculateEstimatedFees(netTonnage, SDRRate)
        });
      }
    } else {
      this.estimateFeesForm.patchValue({
        EstimatedFeesValue: "0"
      });
    }
  }
  SDRChanged(event) {
    if (this.estimateFeesForm.controls.EstimatedNetTonnage.valid && this.estimateFeesForm.controls.EstimatedSDR.valid) {
      let SDRRate = event.target.value;
      let netTonnage = this.estimateFeesForm.controls.EstimatedNetTonnage.value;
      if (netTonnage != "") {
        this.estimateFeesForm.patchValue({
          EstimatedFeesValue: this.calculateEstimatedFees(netTonnage, SDRRate)
        });
      }
    } else {
      this.estimateFeesForm.patchValue({
        EstimatedFeesValue: "0"
      });
    }
  }
  calculateEstimatedFees(netTonnage, SDRRate) {
    return (5 * netTonnage * SDRRate).toFixed(2);
  }
}


